module.exports = "mutation ($id: ID!) {\n  ActivityDelete(id: $id) {\n    id\n  }\n}\n"